import { ampli } from '../../ampli';
import { IMarketPriceFilter } from '../../constants/filter/marketPriceFilter.constant';
import {
  priceSliderValueMapping,
  PriceSliderValueMappingType,
} from '../../constants/filter/slider/filterSliderConstant';

export const trackMarketPriceFilterEvent = (filters: IMarketPriceFilter[], isAutoOpened: boolean = false) => {
  const property = {
    filter_sort:
      filters.find((filter) => filter.key === 'sorter')?.options.find((option) => option.isSelected)?.optionName ?? '',
    filter_brands:
      filters
        .find((filter) => filter.key === 'filter_brand')
        ?.options.filter((option) => option.isSelected)
        .map((option) => option.optionName)
        .join(',') ?? '',
    filter_engine_output_in_ps:
      filters
        .find((filter) => filter.key === 'engineOutputInPs')
        ?.options.filter((option) => option.isSelected)
        .map((option) => option.value)
        .join(',') ?? '',
    filter_price:
      filters
        .find((filter) => filter.key === 'medianPrice')
        ?.options.filter((option) => option.isSelected)
        .map((option) => priceSliderValueMapping[option.value as PriceSliderValueMappingType])
        .join(',') ?? '',
    is_auto_opened: isAutoOpened,
  };

  ampli.pvmClickMarketPriceFilterSubmit({ ...property });
};
